export const getPhoneDigits = (value) => String(value || '').replace(/\D/g, '');

export const getNormalizedPhoneDigits = (value) => {
    const digits = getPhoneDigits(value);
    return digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
};

export const formatPhoneForDisplay = (value) => {
    const digits = getNormalizedPhoneDigits(value);
    if (digits.length === 10) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return String(value || '');
};

export const isValidSendName = (value) => /^[a-zA-Z\s'-]+$/.test(String(value || '').trim());
export const isValidSendEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
